import React from "react";

const ComposeProvider = ({ providers = [], children }) =>
  providers.reduceRight((acc, providerItem) => {
    const [Provider, providerProps] = Array.isArray(providerItem)
      ? providerItem
      : [providerItem, {}];

    return (
      <Provider {...providerProps}>
        {acc}
      </Provider>
    );
  }, children);

export { ComposeProvider };